<template>
    <div class="footer">
            <el-row >
                <el-col class="col-first" >
                    <img src="@/assets/f.png" width="100%"/>
                </el-col>
                <el-col class="col-second">
                    <div class="col-left">
                        <img src="../assets/logo1.jpg" height="100"/>
                    </div>
                    <div>
                        <span>contact：{{this.alldata.contactInfo}}</span>

                        <span>organization：{{this.alldata.organization}}</span>
                    </div>
                    <div class="col-right">
                        <span>
                            Conference platform of China Non-Ferrous Metal Society
                        </span>
                    </div>
                </el-col>
            </el-row>


    </div>
</template>

<script>
    export default {
      name: "footer",
      data(){
        return{
          id:'17',
          alldata:{},
          bottomBar:'',

        }
      },
      created() {
        this.id=17
      },
      mounted() {
        this.getInformation()
      },
      methods:{
        getInformation(){

          this.$http.get("api/conference/confDetailed/user/"+17).then((res)=>{
            if(res.status==200){
              this.alldata = res.data.data


              this.bottomBar='api'+this.alldata.bottomBar
              console.log(res.data,1234578)
              console.log(this.alldata,'alldata')

            }
          })
        }
      },
      watch:{
        $route:{
          handler() {
            if(this.$route.query.id){
              this.getInformation()
            }
          },
          deep: true,
          immediate:true,
        },
      },
    }
</script>

<style scoped lang="less">
    .footer {
      display: flex;
      flex-direction: column;
        margin-top: 70px;
        //width: 100%;
        background-color: #f2f2f2;
        color: #333;
        text-align: center;
        //height: 300px;
    }

    .col-first{
        margin-top: 50px;
    }
    .col-second{
        .col-left{
            margin-top: 10px;
        }
    }
</style>
